import { render, staticRenderFns } from "./ServicesControl.vue?vue&type=template&id=4af12212&"
import script from "./ServicesControl.vue?vue&type=script&lang=js&"
export * from "./ServicesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports